import { authFetch } from "~/services/fetch";

export async function getAllSubtypesByTypeInterestPoint(id: number): Promise<readonly any[]> {
    const response = await authFetch({
        url: `/interest-point/type/${id}/subtypes`, 
        method: 'GET',
    });
    return response.data;
}